<template>
    <div class="find flex">
        <el-input v-model="value" size="small" />
        <div class="ml-6 shrink-0" v-show="false">
            <el-radio-group v-model="chooseType" size="small">
                <el-radio
                    v-for="(item, index) in radioList"
                    :label="item.value"
                    :key="index"
                >
                    {{ item.label }}
                </el-radio>
            </el-radio-group>
        </div>
    </div>
</template>
<script setup lang="ts">
type option = string | number

type propsType = {
    modelValue: option
    type: option
}

const radioList = [
    {
        label: '精确查找',
        value: 1
    },
    {
        label: '模糊查找',
        value: 2
    }
]

const props = withDefaults(defineProps<propsType>(), {})

const emits = defineEmits(['update:modelValue', 'update:type'])

const chooseType = computed({
    get() {
        return props.type
    },
    set(value) {
        emits('update:type', value)
    }
})

const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emits('update:modelValue', value)
    }
})
</script>
<style lang="scss" scoped></style>
